<template>
  <provider-show-section :title="$t('MESSAGES.centerOwnerData')">
    <div class="provider_show_grid provider_show_grid--2">
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.centerOwnerName") }}</span>
        <p class="provider_show_value">{{ displayValue(ownerName) }}</p>
      </div>
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.centerOwnerImage") }}</span>
        <button
          type="button"
          class="provider_show_thumb"
          :disabled="!ownerImage"
          @click="$emit('preview', ownerImage)"
        >
          <img v-if="ownerImage" loading="lazy" :src="ownerImage" alt="owner" />
          <span v-else class="provider_show_thumb__empty">-</span>
        </button>
      </div>
    </div>
  </provider-show-section>
</template>

<script>
import ProviderShowSection from "./ProviderShowSection.vue";
import { displayValue } from "@/utils/festivalProviderShow";

export default {
  name: "ProviderShowOwner",
  components: { ProviderShowSection },
  props: {
    ownerName: { type: String, default: null },
    ownerImage: { type: String, default: null },
  },
  methods: {
    displayValue,
  },
};
</script>
